import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const STAT = ({ k, v, accent }) => (
    <div className="border-t border-white/[0.06] pt-3">
        <p className="label-tech">{k}</p>
        <p className={`mt-1 font-mono text-sm font-semibold tabular-nums ${accent ? "text-[#31D8FF]" : "text-ink"}`}>{v}</p>
    </div>
);

export const AgentCard = ({ agent, testid }) => (
    <Link
        to={`/agents/${agent.id}`}
        data-testid={testid || `agent-card-${agent.id}`}
        className="group relative flex h-full flex-col border border-white/[0.08] bg-[#0A1627] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#1677FF]/50 hover:shadow-[0_18px_50px_rgba(0,0,0,0.5)]"
    >
        <div className="flex items-center justify-between gap-3">
            <span className="flex items-center gap-2.5 font-mono text-[11px] font-semibold tracking-[0.16em] text-ink">
                <span
                    className={`h-1.5 w-1.5 rounded-full ${agent.status === "ACTIVE" ? "bg-[#31D8FF]" : "bg-[#8D9BB0]"}`}
                />
                {agent.handle}
            </span>
            <span className="border border-white/10 px-2 py-1 font-mono text-[9px] uppercase tracking-[0.18em] text-mute">
                {agent.type}
            </span>
        </div>

        <div className="mt-5 flex flex-wrap gap-1.5">
            {agent.capabilities.slice(0, 3).map((c) => (
                <span key={c} className="border border-[#1677FF]/25 bg-[#1677FF]/[0.07] px-2 py-1 font-mono text-[9px] uppercase tracking-[0.12em] text-[#8CB8FF]">
                    {c}
                </span>
            ))}
        </div>

        <div className="mt-6 grid flex-1 grid-cols-2 gap-x-4 gap-y-3">
            <STAT k="VERIFIED ACTIONS" v={agent.verifiedActions.toLocaleString()} accent />
            <STAT k="REPUTATION" v={agent.reputation.toFixed(1)} />
            <STAT k="SUCCESS RATE" v={`${agent.successRate}%`} />
            <STAT k="TOTAL SETTLED" v={`${agent.totalSettled.toLocaleString()} USDC`} />
        </div>

        <div className="mt-6 flex items-center justify-between border-t border-white/[0.06] pt-4">
            <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-mute/60">DEMO AGENT</span>
            <span className="flex items-center gap-1.5 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-ink transition-colors group-hover:text-[#31D8FF]">
                VIEW PROFILE <ArrowUpRight size={12} />
            </span>
        </div>
    </Link>
);

export default AgentCard;
